<template>
  <FormSection>
    <Card>
      <ElForm
        ref="accountType"
        autocomplete="off"
        :model="accountTypeModel"
        :rules="rules"
        label-position="top"
        @submit.native.prevent="submitAccountTypeForm"
      >
        <ElFormItem prop="type" :label="$t('AUTH.STEPS.ACCOUNT_TYPE')">
          <ElSelect
            v-model="accountTypeModel.type"
            class="show-for-medium"
            name="type"
            required
          >
            <ElOption
              v-for="type in accountTypes"
              :key="type"
              :label="getType(type)"
              :value="type"
            />
          </ElSelect>

          <select
            v-model="accountTypeModel.type"
            class="hide-for-medium"
            name="category"
          >
            <option v-for="type in accountTypes" :key="type" :value="type">
              {{ getType(type) }}
            </option>
          </select>
        </ElFormItem>

        <ElFormItem
          prop="country"
          :label="$t('AUTH.STEPS.ACCOUNT_TYPE.COUNTRY')"
        >
          <ElSelect
            v-model="accountTypeModel.country"
            class="show-for-medium"
            clearable
            required
            filterable
            remote
            :placeholder="$t('COUNTRY')"
            :remote-method="filterCountries"
            @clear="resetCountriesList"
            @change="resetCountriesList"
          >
            <ElOption
              v-for="country in countries"
              :key="country.code"
              :label="getCountryLabel(country)"
              :value="country.code"
            />
          </ElSelect>

          <select
            v-model="accountTypeModel.country"
            class="hide-for-medium"
            name="country"
          >
            <option
              v-for="country in countries"
              :key="country.code"
              :value="country.code"
            >
              {{ getCountryLabel(country) }}
            </option>
          </select>
        </ElFormItem>

        <div class="auth-steps__navigation">
          <div />
          <ElButton type="primary" native-type="submit">
            {{ $t('AUTH.STEPS.NEXT_LEVEL_BTN') }}
          </ElButton>
        </div>
      </ElForm>
    </Card>
  </FormSection>
</template>

<script>
import FormSection from '@@/common/layout/FormSection';
import Card from '@@/common/Card';
import waitFor from '@/utils/waitFor';
import countries from '@/utils/countries';
import form from '@/mixins/form';
import lang from '@/mixins/lang';

export default {
  name: 'AccountType',
  components: { Card, FormSection },
  mixins: [form, lang],

  data() {
    return {
      accountTypeModel: {
        type: 'natural',
        country: 'IR',
      },
      accountTypes: ['natural', 'legal'],
      countries: null,
    };
  },

  computed: {
    rules() {
      const rules = {
        required: true,
        message: this.$t('VALIDATION_REQUIRED_ERR'),
        trigger: ['blur'],
      };

      return {
        type: {
          ...rules,
          type: 'string',
        },
        country: {
          ...rules,
          type: 'string',
        },
      };
    },
  },

  mounted() {
    this.resetCountriesList();
  },

  methods: {
    submitAccountTypeForm() {
      if (!this.isValid('accountType')) {
        return false;
      }
      this.$emit('submitAccountType', this.accountTypeModel);
    },

    getType(type) {
      return this.$t(`AUTH.STEPS.ACCOUNT_TYPE.${type.toUpperCase()}`);
    },

    getCountryLabel(country) {
      if (this.lang !== 'fa') {
        return country.name;
      }
      return country.name_fa;
    },

    filterCountries(query) {
      if (query) {
        waitFor().then(() => {
          this.countries = countries.filter(
            country =>
              country.name.toLowerCase().includes(query.toLowerCase()) ||
              country.name_fa.includes(query),
          );
        });
      } else {
        this.resetCountriesList();
      }
    },

    resetCountriesList() {
      this.countries = countries;
    },
  },
};
</script>
